import { render } from "./OutcomesHeaderBet.vue?vue&type=template&id=ca794d3a"
import script from "./OutcomesHeaderBet.vue?vue&type=script&lang=js"
export * from "./OutcomesHeaderBet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__